import { ListItem, ListItemText } from '@mui/material';
import React from 'react';

import { AppState, fetchProduct, productSelector } from 'cdx-common';
import { useSelector } from 'react-redux';
import { appStore } from '../../store';

export const ProductListItem = (props: { productId: ModelId, loaded: () => void; }) => {

    const product = useSelector((state: AppState) => productSelector.selectById(state, props.productId));

    React.useEffect(() => {
        if (product) {
            props.loaded();
        } else {
            appStore.dispatch(fetchProduct(props.productId));
        }
    }, [product]);
    return product ? <ListItem><ListItemText primary={product.name} /></ListItem> : null;
};
